import { TestQuestion } from '../../test/models';

export default class Utils {
    /**
     * Shuffles array in place.
     * @param {Array} a items The array containing the items.
     */
    static shuffle(a: Array<TestQuestion>) {
        var j, x, i;
        for (i = a.length; i; i--) {
            j = Math.floor(Math.random() * i);
            x = a[i - 1];
            a[i - 1] = a[j];
            a[j] = x;
        }

        return a;
    }

    static detectMicrosoft(): boolean {
        let ua = window.navigator.userAgent;
        return ((ua.indexOf('MSIE') > -1) || ((ua.indexOf('Edge') > -1) || (ua.indexOf('Trident') > -1)))
    }

    static splitCamelCase(str: string): string {
        return str.replace(/([a-z])([A-Z])/g, '$1 $2');
    }
}